import { createTableNoteParagraph } from './docxFunctions'

/** Примечание под таблицей референтных цен (курс ЦБ). */
export function createRefPricingFootnoteBlocks(ref) {
  const blocks = []
  const datePricing = String(ref?.datePricing || '').trim()
  const currencies = Array.isArray(ref?.originCurrency)
    ? ref.originCurrency
    : []

  const parts = []
  // if (datePricing) {
  //   parts.push(`Дата подачи предложения: ${datePricing}.`)
  // }

  const usd = currencies.find(
    c =>
      String(c?.currency || '')
        .toUpperCase()
        .includes('USD') || String(c?.currency || '').includes('доллар')
  )
  if (usd?.rate) {
    parts.push(
      `Среднее значение официального курса ЦБ РФ: ${usd.rate} руб. за 1 доллар США.`
    )
  } else if (currencies.length) {
    const lines = currencies
      .filter(c => c?.currency && c?.rate)
      .map(c => `${c.currency}: ${c.rate} руб.`)
    if (lines.length) parts.push(`Курс валют: ${lines.join('; ')}.`)
  }

  if (!parts.length) return blocks

  parts.forEach(text => {
    blocks.push(createTableNoteParagraph(`Примечание: *${text}`))
  })

  return blocks
}
